module.exports = __webpack_public_path__ + "img/11.8a9e397.png";